export default {
  common: {
    appName: 'Arena Sport Digital',
    loading: 'Loading...',
    search: 'Search',
    searchPlaceholder: 'Search...',
    filter: 'Filter',
    reset: 'Reset',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    add: 'Add',
    back: 'Back',
    next: 'Next',
    previous: 'Previous',
    close: 'Close',
    confirm: 'Confirm',
    submit: 'Submit',
    viewAll: 'View all',
    viewDetail: 'View detail',
    download: 'Download',
    all: 'All',
    yes: 'Yes',
    no: 'No',
    optional: 'optional',
    required: 'required',
    noData: 'No data yet',
    noDataDesc: 'Records will appear here once available.',
    error: 'Something went wrong',
    errorDesc: 'Please try again in a moment.',
    retry: 'Try again',
    showing: 'Showing {from}–{to} of {total}',
    page: 'Page',
    of: 'of',
  },

  nav: {
    home: 'Home',
    about: 'About Us',
    tournaments: 'Tournaments',
    schedule: 'Schedule',
    gallery: 'Gallery',
    register: 'Register',
    login: 'Sign In',
    logout: 'Sign Out',
    dashboard: 'Dashboard',
    privacyPolicy: 'Privacy Policy',
    openMenu: 'Open menu',
    closeMenu: 'Close menu',
    skipToContent: 'Skip to main content',
    mainNav: 'Main navigation',
    scheduleShortcut: 'Event schedules',
    seeAllSchedules: 'See all schedules',
  },

  theme: {
    label: 'Appearance',
    light: 'Light',
    dark: 'Dark',
    system: 'Match system',
    toggle: 'Toggle theme',
  },

  language: {
    label: 'Language',
    indonesian: 'Bahasa Indonesia',
    english: 'English',
    change: 'Change language',
  },

  home: {
    featuredTournament: 'Featured Tournament',
    viewEvent: 'Detail',
    feeEyebrow: 'Fees',
    feeTitle: 'Registration Fees',
    feeSubtitle: 'Cost per athlete for each competition category.',
    feeNote: 'Fees are calculated automatically as you add athletes. The total is shown before payment.',
    contactEyebrow: 'Help',
    contactTitle: 'Contact the Organisers',
    contactSubtitle: 'Something unclear? Reach them directly on WhatsApp.',
    badge: 'Pencak Silat Tournament Platform',
    heroTitleA: 'One Arena',
    heroTitleB: 'For Every',
    heroTitleC: 'Match',
    heroSubtitle:
      'Register contingents, build brackets, schedule arenas, and follow results live. All from one place.',
    ctaRegister: 'Register Now',
    ctaSchedule: 'View Schedule',
    eventInfo: 'Event Info',

    registrationOpen: 'Registration Open',
    registerContingent: 'Register Contingent',
    moreInfo: 'Learn more',

    openEyebrow: 'Happening Now',
    openTitle: 'Open Tournaments',
    allTournaments: 'All Tournaments',
    statusOpen: 'Open',

    ctaEyebrow: 'Ready To Run Your Championship?',
    ctaTitle: 'Start Today',
    ctaText: 'Register contingents, manage athlete profiles, and track match schedules in one place.',
    ctaPrimary: 'Register Contingent',
    ctaSecondary: 'Sign In',

    loadFailed: 'Failed to load data',
    noOpenTournament: 'No open tournaments yet',
    noOpenTournamentDesc: 'Tournaments open for registration will appear here.',
  },

  status: {
    dibuka: 'Registration Open',
    dibukaSingkat: 'Open',
    segeraHadir: 'Coming Soon',
    pendaftaranDitutup: 'Registration Closed',
    ditutup: 'Closed',
    kuotaPenuh: 'Quota Full',
    selesai: 'Finished',
    sembunyikan: 'Hidden',
    belumDibuka: 'Registration not open yet',
    belumDibukaDesc: 'Keep an eye on this page — registration will be announced.',
    ditutupDesc: 'Registration is closed. View the schedule and brackets.',
    kuotaPenuhDesc: 'The participant quota is full; registration is closed.',
    sudahSelesai: 'Championship has finished',
    sudahSelesaiDesc: 'Registration is closed. View the schedule and results.',
    berlangsung: 'Happening Now',
  },

  about: {
    eyebrow: 'About Us',
    titleA: 'Registration System for',
    titleB: 'Pencak Silat Championships',
    desc: 'Arena Sport Digital is a web app that helps pencak silat championship committees manage contingent registrations, payments, arena schedules, and match brackets in one place.',
    panitiaTitle: 'For Committees',
    panitiaText: 'Set up categories, classes, and registration fees; review athlete documents and transfer receipts; then build brackets and schedules per arena.',
    officialTitle: 'For Contingent Officials',
    officialText: 'Register athletes, pay invoices by uploading a transfer receipt, track each athlete\'s registration status, and see their contingent\'s match schedule.',
    publikTitle: 'For Athletes & Spectators',
    publikText: 'View championship information and match schedules without creating an account.',
    ctaTitle: 'Is there a championship open now?',
    ctaDesc: 'See the list of championships, their schedules, and how to register.',
    ctaButton: 'View Tournaments',
  },


  tournament: {
    eyebrow: 'Championship Agenda',
    registrationDeadline: 'Registration Closes',
    deadlinePassed: 'closed',
    deadlineToday: 'closes today',
    deadlineLeft: '{n} days left',
    joinGroup: 'WhatsApp Group',
    title: 'Tournaments',
    subtitle: 'Championships hosted on this platform',
    detail: 'Tournament Detail',
    location: 'Venue',
    date: 'Event Dates',
    technicalMeeting: 'Technical Meeting',
    status: 'Status',
    description: 'Description',
    categories: 'Contested Categories',
    ageCategories: 'Age Groups',
    activities: 'Programme',
    contactPersons: 'Contacts',
    registrationFee: 'Entry Fee',
    document: 'Championship Proposal',
    downloadDocument: 'Download Proposal',
    statusActive: 'Open',
    statusInactive: 'Closed',
    statusDraft: 'Draft',
    statusFinished: 'Finished',
    empty: 'No tournaments yet',
    emptyDesc: 'Open tournaments will be listed on this page.',
    ageRange: '{min}–{max} years',
  },

  schedule: {
    title: 'Match Schedule',
    subtitle: 'Running order by arena',
    tanding: 'Sparring',
    seni: 'Artistic',
    arena: 'Arena',
    matchNumber: 'Bout',
    round: 'Round',
    time: 'Time',
    date: 'Date',
    blueCorner: 'Blue Corner',
    redCorner: 'Red Corner',
    contingent: 'Contingent',
    class: 'Class',
    category: 'Category',
    pool: 'Pool',
    winner: 'Winner',
    tbd: 'To be decided',
    winnerFrom: 'Winner of bout #{number}',
    filterByArena: 'Filter by arena',
    filterByDate: 'Filter by date',
    filterByRound: 'Filter by round',
    allArenas: 'All arenas',
    allDates: 'All dates',
    allRounds: 'All rounds',
    empty: 'Schedule not published yet',
    emptyDesc: 'Bouts will appear once officials finish the draw.',
    statusNotStarted: 'Not started',
    statusInProgress: 'In progress',
    statusFinished: 'Finished',
    exportExcel: 'Download Excel',
    filterDate: 'Filter by date',
    filterArena: 'Filter by arena',
    filterPool: 'Filter by pool',
    filterRound: 'Filter by round',
    filterCategory: 'Filter by category',
    filterGender: 'Filter by gender',
    filterClass: 'Filter by class',
    allPools: 'All pools',
    allCategories: 'All categories',
    allGenders: 'All genders',
    allClasses: 'All classes',
    titleTanding: 'Sparring Match Schedule',
    titleSeni: 'Artistic Match Schedule',
    participant1: 'Competitor 1',
    participant2: 'Competitor 2',
  },

  // Schedule index page (/schedule)
  scheduleIndex: {
    filterEvent: 'Choose Event',
    filterType: 'Match Type',
    eyebrow: 'Match Schedules',
    title: 'Choose an Event',
    subtitle: 'Open the tanding or seni schedule for the event you are following.',
    searchPlaceholder: 'Search event name or city…',
    empty: 'No events yet',
    emptyDesc: 'Schedules appear here once the organisers create an event.',
    noMatch: 'Nothing matches',
    noMatchDesc: 'Try another keyword, or clear the search.',
    clearSearch: 'Clear search',
  },

  auth: {
    loginTitle: 'Sign In',
    loginSubtitle: 'Manage your contingent and athlete entries.',
    registerTitle: 'Create an Account',
    registerSubtitle: 'Register your contingent for a championship.',
    email: 'Email Address',
    // Tanda @ harus di-escape sebagai {'@'} — lihat catatan di id.js.
    emailPlaceholder: "name{'@'}email.com",
    password: 'Password',
    passwordPlaceholder: 'Enter your password',
    passwordConfirm: 'Confirm Password',
    personResponsible: 'Person in Charge',
    personResponsiblePlaceholder: 'Full name',
    rememberMe: 'Remember me',
    forgotPassword: 'Forgot password?',
    loginButton: 'Sign In',
    registerButton: 'Create Account',
    noAccount: "Don't have an account?",
    hasAccount: 'Already have an account?',
    registerHere: 'Register here',
    loginHere: 'Sign in here',
    showPassword: 'Show password',
    hidePassword: 'Hide password',
    passwordHint: 'At least 8 characters, including letters and numbers.',
    loginSuccess: 'Signed in. Welcome back.',
    logoutSuccess: 'You have been signed out.',
    invalidCredentials: 'Incorrect email or password.',
    tooManyAttempts: 'Too many attempts. Please try again in a few minutes.',
    sessionExpired: 'Your session has expired. Please sign in again.',
  },

  registration: {
    eyebrow: 'Contingent Registration',
    titleA: 'Register Your',
    titleB: 'Contingent',
    titleC: '',
    stepAccount: 'Account',
    stepCategory: 'Categories',
    stepOtp: 'Email Verification',
    accountTitle: 'Person In Charge',
    accountHint: 'This account manages every athlete in your contingent.',
    fullName: 'Full Name of Person In Charge',
    fullNamePlaceholder: 'e.g. Budi Santoso',
    passwordPlaceholder: 'At least 8 characters',
    passwordRepeat: 'Type it again',
    strengthWeak: 'Weak',
    strengthFair: 'Fair',
    strengthStrong: 'Strong',
    categoryTitle: 'Categories You Will Enter',
    categoryHint:
      'Pick the categories your contingent will compete in. You can change this any time after the account is created.',
    categoryEmpty: 'Categories not announced yet',
    categoryEmptyDesc: 'You can still create an account and choose categories later.',
    perAthlete: '/ athlete',
    selectedCount: 'Categories selected',
    estimatedCost: 'Estimated cost per athlete',
    costNote:
      'The final amount is recalculated by officials based on how many athletes you register.',
    otpTitle: 'Verify Your Email Address',
    otpHint: 'We sent a 6-digit OTP verification code to:',
    otpLabel: 'Enter 6-Digit OTP Code',
    otpPlaceholder: '000000',
    resendOtp: 'Resend OTP Code',
    resendOtpIn: 'Resend code in {n}s',
    sendingOtp: 'Sending verification code...',
    verifyingOtp: 'Verifying OTP code...',
    verifyAndFinish: 'Verify & Complete Registration',
    changeEmail: 'Change Account Info',
    continue: 'Continue',
    sendOtpButton: 'Send Verification Code',
    finish: 'Complete Registration',
    submitting: 'Registering...',
    checkFields: 'Please review the highlighted fields.',
    failed: 'Registration failed. Please try again.',
    success: 'Account created and email verified. Welcome aboard!',
    needHelp: 'Need help?',
    help1: 'One account can be used for several tournaments at once.',
    help2: 'Athletes are added after the account exists, from the Athletes menu.',
    help3: 'Invoices are issued automatically once athletes are registered.',
  },

  validation: {
    required: '{field} is required.',
    email: 'Please enter a valid email address.',
    minLength: '{field} must be at least {min} characters.',
    passwordMismatch: 'Passwords do not match.',
    nameRequired: 'Person in charge is required.',
    emailRequired: 'Email is required.',
    passwordRequired: 'Password is required.',
    passwordMin: 'Password must be at least 8 characters.',
    passwordFormat: 'Password must contain both letters and numbers.',
    passwordRepeatMismatch: 'Passwords do not match.',
  },

  footer: {
    tagline:
      'Pencak silat tournament management — from contingent registration to the medal ceremony.',
    explore: 'Explore',
    contact: 'Contact',
    appearance: 'Appearance',
    followUs: 'Follow Us',
    rights: 'All rights reserved.',
  },
};
